var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTotal = function SvgTotal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 10,
    fill: "#276EF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.5 16.003a.5.5 0 01-.496.497H7.996a.496.496 0 01-.496-.497V15.5h9V9.65l-4 3.6-5-4.5V8a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v8.003zM8.717 8.5l3.783 3.405L16.283 8.5H8.717zm-2.217 5h4v1h-4v-1zm0-2.5H9v1H6.5v-1z"
  })));
};
export default SvgTotal;